import React from 'react';
import PropTypes from 'prop-types';
import {createContext} from "react";

import {Menu} from "@mui/material";

SidebarFloatMenu.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    anchorEl: PropTypes.object,
    customMarginLeft: PropTypes.string
};


export const SidebarFloatMenuContext = createContext({
    onClose: () => {}
})

function SidebarFloatMenu({
    open = false,
    onClose = () => {},
    anchorEl = null,
    style = {},
    anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'left',
    },
    transformOrigin= {
        vertical: 'top',
        horizontal: 'left',
    },
    customMarginLeft = null,
    ...props
}) {
    return (
        <SidebarFloatMenuContext.Provider value={{ onClose }}>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={onClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                sx={{
                    marginLeft: customMarginLeft ?? '5%',
                    '.MuiPaper-root': {
                        borderRadius: '8px',
                        background: '#fff',
                        boxShadow: '0 4px 22px 0 rgba(0, 0, 0, 0.12)',
                    },
                    '.MuiMenuItem-root' : {
                        padding: '8px'
                    },
                    '.MuiList-root' : {
                        padding: '0px'
                    },
                    ...style
                }}
            >
                {props.children}
            </Menu>
        </SidebarFloatMenuContext.Provider>
    );
}

export default SidebarFloatMenu;
